import { render, staticRenderFns } from "./SendSms.vue?vue&type=template&id=2efc271a&scoped=true"
import script from "./SendSms.vue?vue&type=script&lang=js"
export * from "./SendSms.vue?vue&type=script&lang=js"
import style0 from "./SendSms.vue?vue&type=style&index=0&id=2efc271a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc271a",
  null
  
)

export default component.exports